var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('vue-title', {
    attrs: {
      "title": "Login - Your Indoor Cycling Solution"
    }
  }), _c('section', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-xl-6 col-lg-7 col-md-9 mx-auto"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('h3', [_vm._v("SIGN IN")]), _c('span', [_vm._v("Using your MyWhoosh account")]), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.loginHandler();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(" Email Address")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.email,
      expression: "form.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "required": "",
      "id": "email",
      "placeholder": "Email Address",
      "autocomplete": "chrome-off"
    },
    domProps: {
      "value": _vm.form.email
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value);
      }
    }
  }), _vm.submitted && _vm.getError('email') ? _c('div', {
    staticClass: "text-danger text-left"
  }, [_vm._v(" Please enter correct email ")]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.password,
      expression: "form.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "required": "",
      "id": "password",
      "placeholder": "Password",
      "autocomplete": "chrome-off"
    },
    domProps: {
      "value": _vm.form.password
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value);
      }
    }
  }), _vm.submitted && _vm.getError('password') ? _c('div', {
    staticClass: "text-danger text-left"
  }, [_vm._v(" Password must be at least 6 characters ")]) : _vm._e(), _c('router-link', {
    staticStyle: {
      "float": "right",
      "font-size": "12px",
      "color": "#2e2e2e",
      "margin-top": "10px"
    },
    attrs: {
      "to": {
        name: 'forgetpassword'
      }
    }
  }, [_vm._v(" Forgot Password? ")])], 1), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _c('re-captcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.sitekey
    },
    on: {
      "change": _vm.onRecaptchaChange
    }
  }), _c('button', {
    class: ['btn-universal', {
      'btn-disabled': !_vm.recaptchaVerified
    }],
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.recaptchaVerified
    }
  }, [_vm._v(" Submit ")]), _c('ul', {
    staticClass: "list-inline"
  }, [_c('li', [_c('div', {
    staticClass: "custom-control custom-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.remember,
      expression: "form.remember"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "type": "checkbox",
      "id": "customCheck"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.remember) ? _vm._i(_vm.form.remember, null) > -1 : _vm.form.remember
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.form.remember,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "remember", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "remember", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "remember", $$c);
        }
      }
    }
  }), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "customCheck"
    }
  }, [_vm._v(" Stay signed in ")])])]), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("Create New Account?")])], 1)])], 1)])])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }